export const staircaseConfig = {
    gameSlug: 'path-finder',
    category: 'terre_navigation',
    variable: 'n_items',
    startValue: 2,
    minValue: 1,
    maxValue: 8,
    stepSizesByPhase: [1, 1, 1],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 16,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, gridSize: 5, optimalityTolerance: 1.5, label: 'Découverte' };
    }
    if (level <= 20) {
        return { level, gridSize: 6, optimalityTolerance: 1.3, label: 'Trace serrée' };
    }
    if (level <= 30) {
        return { level, gridSize: 7, optimalityTolerance: 1.2, label: 'Optimisation' };
    }
    if (level <= 40) {
        return { level, gridSize: 7, optimalityTolerance: 1.1, label: 'Planning fin' };
    }
    return { level, gridSize: 8, optimalityTolerance: 1.05, label: 'Path optimal' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    prePuzzleMs: 600,
    feedbackMs: 1000,
    itiMs: 700,
    /** Pour respecter le contrat staircase value (le moteur ne s'arrête pas si on ignore stim.value). */
    minCheckpoints: 1,
};
export const paradigmMeta = {
    slug: 'path-finder',
    paradigm: 'Maze planning (Shallice 1982 / Porteus 1959)',
    masterMage: 'Ondine (eau-mémoire) + Garek (terre-spatial)',
    category: 'terre_navigation',
    goal: 'Planifier un chemin avant de le tracer — fonction exécutive pure.',
};
//# sourceMappingURL=params.js.map